import React from "react";

import ModalBase from "./ModalBase";
import LoginAccessCodes from "../Admin/LoginAccessCodes";

interface AccessCodesModalProps {
  /** Provided by ModalGlobal — closes the modal. */
  onClose: (result?: any) => void;
}

// Thin ModalBase shell around the existing access-codes manager, opened from the Admin page's User Management row
const AccessCodesModal: React.FC<AccessCodesModalProps> = ({ onClose }) => (
  <ModalBase title="Access Codes" onClose={() => onClose()} size="md">
    <LoginAccessCodes />
  </ModalBase>
);

export default AccessCodesModal;
